import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import authenticationService from './services/authenticationService';
import siderbarService from './services/siderbarService';
import countryDataService from './services/countryDataService';
import schoolRegistrationService from './services/schoolRegistrationService';
import appDataService from './services/appDataService';
import userAccountService from './services/userAccountService';

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  
  modules: {
    authenticationService,
    siderbarService,
    countryDataService,
    schoolRegistrationService,
    appDataService,
    userAccountService,
  },
  plugins: [createPersistedState({ storage: window.localStorage })],
  strict: debug,
})
